import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import _ from 'lodash';

import { APP_BACKEND_LOGOUT_URL } from '@/config';
import storage from '@/utils/storage';

function authRequestInterceptor(config: AxiosRequestConfig) {
  const token = storage.getToken();

  config.headers.Accept = 'application/json';

  if (config && config?.params && config?.params?.isPublic) {
    return config;
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}

function authResponseErrorInterceptor(error: any) {
  if (error.response && error.response.status && error.response.status === 401) {
    storage.clear();
    window.location.assign(APP_BACKEND_LOGOUT_URL);
    return Promise.reject(error);
  }
  return Promise.reject(error);
}

function authResponseInterceptor(response: AxiosResponse) {
  if (response.status === 401) {
    storage.clear();
    window.location.assign(APP_BACKEND_LOGOUT_URL);
  }
  return (response && response?.data) || {};
}

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(authResponseInterceptor, authResponseErrorInterceptor);

export type GetterAxios = {
  callback: any;
  parameters?: any;
};

const callable = (callback: any, parameters: any) => {
  return callback(parameters);
};

export const getAllAxiosData = (
  getter: GetterAxios[],
  setter: [],
  onErrorCallback?: (error: any) => void
) => {
  return axios
    .all(
      _.map(getter, (item: GetterAxios) => {
        return callable(item.callback, item.parameters);
      })
    )
    .then(
      axios.spread((...res: any) => {
        _.map(res, (item, key: any) => {
          if (!item) {
            const errorSource = getter[key]?.callback?.name || 'unknown method';
            throw new Error(`Critical error fetching data in: ${errorSource}`);
          }

          callable(setter[key], item);
        });
      })
    )
    .catch((error) => {
      if (onErrorCallback) {
        onErrorCallback(error);
      } else {
        //throw new Error(error);
        return {
          type: 'error',
          message: error,
        };
      }
    });
};

export default axios;
